import { api } from '../lib/api';

/**
 * Letting an MCP client sign in as you. The API records the client's
 * request and sends the browser to /authorize?request=<id>; this is what the
 * page asks about it and how it answers.
 */

/** GET /v1/oauth/requests/:id */
export interface OAuthRequestDetails {
  client: { name: string };
  /** Where the browser goes afterwards: a host, or an app scheme. */
  redirectHost: string | null;
  expiresAt: string;
  alreadyHandled: boolean;
  /** Whether the signed-in person may connect: a Team feature. Null when signed out. */
  included: boolean | null;
}

export function fetchOAuthRequest(requestId: string): Promise<OAuthRequestDetails> {
  // With a token when there is one, so the answer can say whether this
  // person's plan includes connecting; the page works signed out too.
  return api<OAuthRequestDetails>(`/v1/oauth/requests/${encodeURIComponent(requestId)}`, { auth: 'optional' });
}

export function decideOAuthRequest(
  requestId: string,
  decision: 'approve' | 'deny',
): Promise<{ ok: boolean; decision: string; redirectTo: string }> {
  return api(`/v1/oauth/requests/${encodeURIComponent(requestId)}/decision`, {
    method: 'POST',
    body: { decision },
  });
}
